import { useAppState } from 'Context/AppContext/AppContext'

// This is a production ID. Since we only have the one org in this edge case,
// using the naive solution here. This org is a funder that was given a
// nonprofit org or something like that.
const ORG_IDS_DENY_LIST: number[] = [17597]

const useCommunityGatingRules = () => {
  const { nonprofitOrgConfig, userConfig } = useAppState()
  const isInAllowedList = !ORG_IDS_DENY_LIST.includes(nonprofitOrgConfig.orgId)
  const isPremium = userConfig.permissions.includes('page:community:premium')

  return {
    isUserAllowed: isInAllowedList,
    isPremium,
  }
}

export default useCommunityGatingRules
